// extracted by mini-css-extract-plugin
module.exports = {"container":"skeleton_container__18DvW","content":"skeleton_content__1Y_gc","small":"skeleton_small__T8CV3","medium":"skeleton_medium__W35_u"};